import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import IconButton from '@mui/material/IconButton';
import HighlightOff from '@mui/icons-material/HighlightOff';
import { Chip } from '@mui/material';
import Box from '../Box/Box';
const useStyles = makeStyles(createStyles({
    root: {
        '@media (min-width:600px)': {
            paddingInline: '1.5em',
            paddingTop: '0.1em',
        },
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
    },
    appliedResultsLabel: {
        '@media (min-width:600px)': {
            color: '#EFEFEF',
        },
        color: '#5E5E5E',
        fontWeight: 'bolder',
        paddingRight: '0.6em',
        display: 'flex',
        alignItems: 'center',
    },
    appliedResultChip: {
        '@media (min-width: 600px)': {
            color: '#EFEFEF',
        },
        fontWeight: 'bolder',
        height: '2.5em',
        color: '#5E5E5E',
        alignItems: 'center',
        marginRight: '5px',
    },
    chipContainer: {
        display: 'flex',
        flex: '1',
        overflow: 'auto',
        scrollbarWidth: 'thin',
        alignItems: 'center',
        paddingTop: '7px',
        paddingBottom: '7px',
        '@media (min-width:600px)': {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    clearButton: {
        color: 'rgba(0,0,0,0.6)',
        '@media (min-width:600px)': {
            color: 'white',
        },
        '& .Mui-disabled': {
            color: 'rgba(256,256,256, 0.3)',
        },
    },
    clearIcon: {
        '@media (min-width:600px)': {
            height: '0.8em',
            width: '0.8em',
        },
        height: '1.2em',
        width: '1.2em',
    },
}));
function AppliedFiltersBar(props) {
    const { appliedFilters, onClearButtonTap, clearDisabled } = props;
    const isAppliedResultsContainerVisible = (appliedFilters.length > 0);
    const classes = useStyles();
    return (isAppliedResultsContainerVisible ? (_jsxs(Box, { className: `${classes.root} ${classes.appliedResultsContainer}`, children: [_jsx(Typography, { variant: "caption", className: `${classes.appliedResultsLabel} appliedResultsLabel`, children: "Applied Filters:" }), _jsxs(Box, { className: `${classes.chipContainer}`, children: [appliedFilters.map((appliedMatch, index) => _jsx(Chip, { variant: "outlined", className: `${classes.appliedResultChip} appliedResultChip`, label: appliedMatch.label }, `appliedBadge_${index}`)), _jsx(IconButton, { size: "small", "aria-label": "clear", disabled: clearDisabled, onClick: onClearButtonTap, className: classes.clearButton, children: _jsx(HighlightOff, { className: `${classes.clearIcon} clearIcon` }) })] })] })) : _jsx(Box, { className: classes.root }));
}
export default AppliedFiltersBar;
